import { container } from '@/di/container';
import { Congrupo } from '@/domain/entities/congrupo';
import { ICongrupoRepository } from '@/domain/repositories/ICongrupoRepository';
import { useEffect, useState } from 'react';

export function useCongrupo(table?: string) {
  const [data, setData] = useState<Congrupo[]>([]);

  const repository =
    container.get<ICongrupoRepository>(
      'ICongrupoRepository'
    );

  const load = async () => {
    if (!table) return;

    const result = await repository.findAll(table);

    setData(result);
  };

  const loadByGroup = async (
    table: string,
    group: string | number
  ) => {
    const result = await repository.findGroup(
      table,
      String(group)
    );

    setData(result);
  };

  const create = async (
    table: string,
    data: Omit<Congrupo, 'id'>
  ) => {

    return await repository.create(table, data);
  };

  useEffect(() => {
    load();
  }, [table]);

  return {
    data,
    reload: load,
    loadByGroup,
    create,
  };
}